
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from "next/head"

import SEO from "@/meta/SEO"
import { getHelpCenterArticleProps } from "@/organisms/HelpCenterArticle/functions/getHelpCenterArticleProps"
import HelpCenterArticle from "@/organisms/HelpCenterArticle/HelpCenterArticle"
import Help from "@/templates/Help/Help"

function FansiClassHelp() {
  const sectionsList = [
    ["what_is_fansi_class"],
    ["i_cannot_attend_the_fansi_class_i_purchased"],
  ]

  const props = getHelpCenterArticleProps(
    "helpFansiClass",
    "fansi_class",
    sectionsList
  )

  return (
    <>
      <Head>
        <title>Centrum pomocy | fansi.pl</title>
        <SEO description="W Centrum Pomocy znajdziesz odpowiedzi na najczęściej zadawane pytania dotyczące platformy fansi, logowania oraz zakupu produktów od influencerów." />
        {/* <meta name="robots" content="noindex,nofollow" /> */}
      </Head>
      <HelpCenterArticle {...props} />
    </>
  )
}
FansiClassHelp.Layout = Help
export default FansiClassHelp


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/help/fansi-class',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  